export function ChevronIcon() {
  return (
    <svg
      className="ver-chevron"
      width="8"
      height="5"
      viewBox="0 0 8 5"
      aria-hidden="true"
    >
      <path
        d="M1 1l3 3 3-3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
